module.exports = __webpack_public_path__ + "static/img/gz-kf.b6736be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/gz-kf.png
// module id = BRqn
// module chunks = 1